var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "header",
    {
      staticClass:
        "dashboard-header flex items-center justify-between mb-6 font-outfit",
    },
    [
      _c("div", { staticClass: "header-content" }, [
        _c(
          "h1",
          {
            staticClass:
              "text-mobile-heading sm:text-heading font-semibold font-outfit leading-10 sm:mt-4",
          },
          [_vm._v(_vm._s(_vm.title))]
        ),
        _vm.subtitle
          ? _c("p", { staticClass: "text-sm text-gray-600" }, [
              _vm._v(" " + _vm._s(_vm.subtitle) + " "),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "extra" },
        [
          _vm._t("extra", function () {
            return [
              _vm.showBtn
                ? _c(
                    "UiButton",
                    {
                      staticClass: "group",
                      attrs: {
                        borderStyles: "new-btn-style",
                        size: "lg",
                        variant: "black",
                        buttonClasses: _vm.btnClass,
                      },
                      on: { click: _vm.handleClick },
                    },
                    [_vm._t("icon"), _vm._v(" " + _vm._s(_vm.btnText) + " ")],
                    2
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }